import React from 'react'
import { FormattedMessage } from 'react-intl'

import Button from 'components/Button'

import { ValidationProposalModalFooter, ValidationProposalModalText } from '../style'

const ValidationProposalModal = ({ sections, toggleModal }) => {
  const closeModal = () => {
    toggleModal(false)
  }
  return (
    <div>
      <ValidationProposalModalText>
        <FormattedMessage id="validationMonitoring" />
        <br />
        <br />
        Pages: <b>{sections.filter((item) => item !== 'oneTabRequired').join(', ')}</b>
      </ValidationProposalModalText>
      <ValidationProposalModalFooter>
        <Button type="primary" onClick={closeModal}>
          <FormattedMessage id="goBack" />
        </Button>
      </ValidationProposalModalFooter>
    </div>
  )
}

export default ValidationProposalModal
